<template>
	<page-view :title="true">
		<a-card>
			<a-form-model
			  ref="ruleForm"
			  :rules="formRules"
			  :model="formData"
			  :labelCol="labelCol"
			  :wrapperCol="wrapperCol"
			  class="form"
			>
			<a-row :gutter="24">
			<a-col :sm="24" :md="12" :xl="8">
			  <a-form-model-item label="代码" prop="code">
			    <a-input
			      v-model="formData.code"
			      placeholder="请输入代码"
			    ></a-input>
			  </a-form-model-item>
			</a-col>
			<a-col :sm="24" :md="12" :xl="8">
			  <a-form-model-item label="名称" prop="descript">
			    <a-input
			      v-model="formData.descript"
			      placeholder="请输入名称"
			    ></a-input>
			  </a-form-model-item>
			</a-col>
			<a-col :sm="24" :md="12" :xl="8">
			  <a-form-model-item label="状态" prop="sta">
			    <a-select
			      v-model="formData.sta"
			      placeholder="请选择状态"
			    >
			      <a-select-option
			        v-for="item in staList"
			        :key="item.value"
			        :value="item.value"
			        >{{ item.label }}</a-select-option
			      >
			    </a-select>
			  </a-form-model-item>
			</a-col>
			<a-col :sm="24" :md="12" :xl="8">
			  <a-form-model-item label="类型" prop="type">
			    <a-select
			      v-model="formData.type"
			      placeholder="请选择类型"
			    >
			      <a-select-option
			        v-for="item in typeList"
			        :key="item.value"
			        :value="item.value"
			        >{{ item.label }}</a-select-option
			      >
			    </a-select>
			  </a-form-model-item>
			</a-col>
			
			<a-col :sm="24" :md="12" :xl="8">
			  <a-form-model-item label="原价(元)" prop="originalPrice"
			    ><a-input
			      type="number"
			      suffix="￥"
			      v-model="formData.originalPrice"
			      placeholder="请输入原价"
				   :min="0"
			    ></a-input
			  ></a-form-model-item>
			</a-col>
			<a-col :sm="24" :md="12" :xl="8">
			  <a-form-model-item label="售价(元)" prop="salePrice"
			    ><a-input
			      type="number"
			      suffix="￥"
			      v-model="formData.salePrice"
			      placeholder="请输入售价"
				   :min="0"
			    ></a-input
			  ></a-form-model-item>
			</a-col>
			<a-col :sm="24" :md="12" :xl="8">
			  <a-form-model-item label="单价(元)" prop="unitPrice"
			    ><a-input
			      type="number"
			      suffix="￥"
			      v-model="formData.unitPrice"
			      placeholder="请输入单价"
				  :min="0"
			    ></a-input
			  ></a-form-model-item>
			</a-col>
			<a-col :sm="24" :md="12" :xl="8">
			  <a-form-model-item label="合同份数" prop="value"
			    ><a-input
			      type="number"
			      v-model="formData.value"
			      placeholder="请输入份数"
				  :min="1"
			    ></a-input
			  ></a-form-model-item>
			</a-col>
			<a-col :sm="24" :md="12" :xl="8">
			  <a-form-model-item
			    label="是否停用"
			  >
			    <a-switch
			      checked-children="是"
			      un-checked-children="否"
			      :checked="formData.isHalt == 'T' ? true : false"
			      @change="onChange('isHalt')"
			    />
			  </a-form-model-item>
			</a-col>
			<a-col :sm="24" :md="12" :xl="8">
				<a-form-model-item label="排序" prop="listOrder">
				  <a-input-number v-model="formData.listOrder" :min="1" :max="99999" />
				</a-form-model-item>
			</a-col>
			<a-col :sm="24" :md="24" :xl="24">
			  <a-form-model-item
			  :label-col="{ span: 2 }"
			  :wrapper-col="{ span: 22 }"
			    label="备注"
			    prop="remark"
			    ><a-input v-model="formData.remark" type="textarea"
			  /></a-form-model-item>
			</a-col>
			</a-row>
			</a-form-model>
			
			<div class="operation">
				<a-button style="margin-left: 8px" @click="back">返回</a-button>
				<a-button type="primary" style="margin-left: 8px" :loading="loading" @click="ok">保存</a-button>
			</div>
		</a-card>
		
	</page-view>
</template>

<script>
import { PageView } from '@/layouts';
export default {
	name: 'ContractGoodsInfo',
	components: {
		PageView
	},
	data() {
		return {
			query: null,
			userInfo: null,
			loading: false,
			labelCol: { span: 8 },
			wrapperCol: { span: 16 },
			staList: [
				{label:'待上线',value:'R'},
				{label:'已上线',value:'I'},
				{label:'已下线',value:'X'}
			],
			typeList: [
				{label:'套餐',value:'package'},
				{label:'零售',value:'single'}
			],
			formData: {
			  code: '', //套餐代码
			  descript: '', //套餐名称
			  sta: 'R', //状态
			  type: 'package', //类型
			  originalPrice: 0, //原价
			  salePrice: 0, //售价
			  unitPrice: 0,//单价
			  value: 1,//合同份数
			  isHalt: 'F',//是否停用
			  remark: '',//备注
			  listOrder: 0 //排序
			},
			formRules: {
			  code: [{ required: true, message: "请输入代码" }],
			  descript: [{ required: true, message: "请输入名称" }],
			  sta: [{ required: true, message: "请选择状态" }],
			  type: [{ required: true, message: "请选择类型" }],
			  originalPrice: [{ required: true, message: "请输入原价" }],
			  salePrice: [{ required: true, message: "请输入售价" }],
			  unitPrice: [{ required: true, message: "请输入单价" }],
			  value: [{ required: true, message: "请输入份数" }]
			},
		};
	},
	created() {
		this.userInfo = this.$store.getters.userInfo;
		this.query = this.$route.query;
		if (this.query && this.query.opt == 'modify') {
			Object.assign(this.formData, this.query.info);
		}
	},
	methods: {
		onChange(column) {
		  if (this.formData[column] == "T") {
		    this.formData[column] = "F";
		  } else {
		    this.formData[column] = "T";
		  }
		},
		back() {
			this.$router.push({
				name: 'ContractGoodsList'
			});
		},
		ok(){
			this.$refs.ruleForm.validate(valid => {
			  if (valid) {
				  
				let action='';
				if (this.query.opt == 'add') {
					action = 'saveContractGoodsBase';
				} else if (this.query.opt=='modify'){
					action = 'modifyContractGoodsBase';
				}
				if (action) {
					this.loading = true;
					this.$http.roomBksApi[action](this.formData).then(res=>{
						this.loading = true;
						if (res && res.result == 0) {
							this.back();
							this.$message.success(res.msg);
						}
					});
				}
			  } 
			});
		}
	}
};
</script>

<style lang="less">
.operation {
	text-align: center;
	margin-top: 50px;
}
</style>
